module.exports = __webpack_public_path__ + "img/Gabon.46c9907d.svg";